import React, { useCallback, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import api from '../../services/api';

import { useAlert } from '../../hooks/alert';
import getValidationErrors from '../../utils/getValidationErrors';

import Input from '../../components/Input';

const ClientsRegister: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const [loading, setLoading] = useState(false);

  const { showAlert } = useAlert();
  const history = useHistory();

  const handleSubmit = useCallback(
    async (data: object) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          company: Yup.string().required('Digite a razão social'),
          cnpj: Yup.string().required('Digite o CNPJ'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const response = await api.post('user-clients', data);

        showAlert({
          type: 'success',
          title: 'Cadastro realizado com sucesso',
          description: 'O cliente foi cadastrado.',
        });

        history.push({
          pathname: '/budgets/register',
          search: `client_id=${response.data.client.id}`,
        });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
        } else {
          showAlert({
            type: 'error',
            title: 'Algum erro aconteceu',
            description: error.response?.data?.error,
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [history, showAlert],
  );

  return (
    <>
      <Form onSubmit={handleSubmit} ref={formRef}>
        <h5 className="spacer">CADASTRAR NOVO CLIENTE</h5>

        <p>
          Lorem ipsum dolor sit amet, qui minim labore adipisicing minim sint
          cillum sint consectetur cupidatat.
        </p>

        <div className="spacer" />

        <div className="form-group">
          <label htmlFor="company">RAZÃO SOCIAL</label>
          <Input
            name="company"
            type="text"
            className="form-control"
            id="company"
          />
        </div>

        <div className="form-group">
          <label htmlFor="cnpj">CNPJ</label>
          <Input name="cnpj" type="text" className="form-control" id="cnpj" />
        </div>

        <div className="row">
          <div className="col d-flex align-items-center">
            <Link to="/budgets/register">Voltar</Link>
          </div>
          <div className="col text-right">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'CARREGANDO...' : 'CADASTRAR'}
            </button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default ClientsRegister;
